var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "59px",
    viewBox: "0 0 54 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "player-one") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "player-one"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    fill: "#000000",
    cx: 27,
    cy: 27,
    r: 27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-40",
    fill: "#000000",
    cx: 27,
    cy: 32,
    r: 27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#FD6687",
    cx: 27,
    cy: 27,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(19.000000, 17.000000)",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,26.75 C12.627417,26.75 18,21.377417 18,14.75 C18,8.122583 12.627417,2.75 6,2.75",
    id: "Oval-Copy-11",
    transform: "translate(12.000000, 14.750000) rotate(90.000000) translate(-12.000000, -14.750000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 5.9844035,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 5.9844035,
    id: "Path-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerOne);
export default __webpack_public_path__ + "static/media/player-one.dddd4c6dd39939e6572b23602ed52bf8.svg";
export { ForwardRef as ReactComponent };